<div class="card-body">
    <div id="apex-basic-radialbar-chart"></div>
</div>